export default __webpack_public_path__ + "static/media/footer-gallery-3.2e6f8a8f.jpg";